/**
 * Maps the instance-detail payload to the view model the Instance Detail header
 * and tabs render (CT-4188). ISO timestamps stay raw so screens can localize
 * them with `formatRelativeTime(..., t)` (CT-4995). `lastRunIso` is the same
 * value for Basic Info absolute formatting.
 */
export const mapApiInstanceToUi = (i) => {
  if (!i) return null;
  return {
    instanceId: i.instance_id,
    name: i.name,
    providerSlug: i.provider_slug,
    providerName: i.provider_name,
    official: Boolean(i.official),
    status: i.status,
    managedBy: i.managed_by,
    authMethod: i.auth_method,
    credentialExpiresAt: i.credential_expires_at ?? null,
    lastRun: i.last_run ?? null,
    lastRunIso: i.last_run ?? null,
    connectedAt: i.connected_at ?? null,
    connectedBy: i.connected_by ?? null,
    errors24h: i.errors_24h ?? 0,
    instanceCount: i.instance_count ?? 1,
  };
};
